// Константы раздела «КМ'ы». Справочники типов и статусов приходят с сервера (/marking/meta)
import { ExportFormat, MarkingFilters, SortState } from './types';

export const EMPTY_FILTERS: MarkingFilters = {
  search: '',
  types: [],
  statuses: [],
  pharmacies: [],
  storages: [],
  dateFrom: '',
  dateTo: '',
  products: []
};

export const DEFAULT_SORT: SortState = { sortBy: 'date', sortOrder: 'desc' };
export const PAGE_SIZES = [25, 50, 100, 200];
export const DEFAULT_PAGE_SIZE = 50;
export const EXPORT_FORMATS: Array<{ value: ExportFormat; label: string }> = [
  { value: 'xlsx', label: 'Excel (.xlsx)' },
  { value: 'csv', label: 'CSV' }
];

/** Колонки выгрузки - ключи совпадают с серверными (backend/documents/routes/markingV2.js) */
export const EXPORT_COLUMNS: Array<{ key: string; label: string }> = [
  { key: 'code', label: 'Код маркировки' },
  { key: 'product', label: 'Товар' },
  { key: 'type', label: 'Тип документа' },
  { key: 'status', label: 'Статус накладной' },
  { key: 'documentNumber', label: '№ документа' },
  { key: 'sender', label: 'Отправитель' },
  { key: 'receiver', label: 'Получатель' },
  { key: 'date', label: 'Дата записи' }
];

/** Есть ли хотя бы один активный фильтр (включая поиск) */
export const hasAnyFilter = (f: MarkingFilters): boolean => (
  Boolean(f.search.trim()) || f.types.length > 0 || f.statuses.length > 0 || f.pharmacies.length > 0 ||
  f.storages.length > 0 || Boolean(f.dateFrom) || Boolean(f.dateTo) || f.products.length > 0
);

/** Фильтры без поиска, спрятанные под кнопкой «Ещё фильтры» - для бейджа со счётчиком */
export const countAdvancedFilters = (f: MarkingFilters): number => (
  (f.types.length ? 1 : 0) + (f.statuses.length ? 1 : 0) + (f.storages.length ? 1 : 0) +
  (f.dateFrom || f.dateTo ? 1 : 0) + (f.products.length ? 1 : 0)
);
